import {ICriteriaReportContext} from "../models/CriteriaModels";

export const PRINT_STYLES = `
  <style>
    @media print {
      @page {
        margin: 7mm;
      }
  
      table td.bg-part {
        background-color: gray !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact; /* Firefox */
      }
    
      table td.bg-chapter {
        background-color: #ccc !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact; /* Firefox */
      }
    }
  </style>
`;

export const INITIAL_TYPE = {
  modalType: "",
  form: "",
}

export const LIST_CRITERIA = {
  _83_TIEU_CHI: {name: "Bộ 83 tiêu chí", value: 1},
  _CHI_SO_CHAT_LUONG: {name: "Bộ tiêu chí quản lý chỉ số chất lượng bệnh viện", value: 3},
  _TIEU_CHUAN_CHAT_LUONG: {name: "Bộ tiêu chí đánh giá tiêu chuẩn chất lượng cơ bản với bệnh viện", value: 4},
  _MUC_DO_ATPT: {name: "Bộ tiêu chí chất lượng đánh giá mức độ an toàn phẫu thuật", value: 5},
  _XEP_CAP_CHUYEN_MON_KT: {name: "Bộ tiêu chí xếp cấp chuyên môn kỹ thuật", value: 6},
}

export const DEFAULT_CRITERIA_REPORT_CONTEXT: ICriteriaReportContext = {
  isView: false,
  criteria: null,
  setCriteria: () => {},
  criteriaType: null,
}

export const CRITERIA_REPORT_MODEL_JSON = {
  [LIST_CRITERIA._83_TIEU_CHI.value]: "REPORT-EVALUATION-83Criteria",
  [LIST_CRITERIA._CHI_SO_CHAT_LUONG.value]: "REPORT-EVALUATION-qualityIndicator",
  [LIST_CRITERIA._TIEU_CHUAN_CHAT_LUONG.value]: "REPORT-EVALUATION-qualityStandard",
  [LIST_CRITERIA._MUC_DO_ATPT.value]: "REPORT-EVALUATION-surgicalSafetyQuality",
  [LIST_CRITERIA._XEP_CAP_CHUYEN_MON_KT.value]: "REPORT-EVALUATION-technicalLevel",
}
